/* Nividas search: Swedish and English, typos forgiven (2026-10-21).
   Customers are Swedish, the site is English. Before a search goes out —
   the type-ahead dropdown and the results page — each word is:
     1. corrected if it is a near-miss of a word we know (glasogon,
        galsögon, glsögon, receptbelagd, viena, prescripton), and then
     2. put into the site's English ("svarta glasögon" → "black glasses"),
   so product names match. snippets/nv-search.liquid then reads the intent
   (prescription / sunglasses / reading glasses) and groups the results.

   A search that is only a category ("glasögon", "solglasögon",
   "läsglasögon", "prescription glasses") goes straight to that collection.
   When a word was corrected, the results page and the dropdown say
   "Showing results for …", with a link to search the original words.

   Correction never guesses (Jakob 2026-10-21: never correct into something
   the customer did not mean):
     - a word we already know is never changed (klara stays klara, not Klaro)
     - å/ä/ö may be left out or typed as a/o (glasogon = glasögon)
     - word families by their start (receptbel… = prescription)
     - otherwise one slip per word, two from 9 letters: a wrong, missing or
       extra letter, or two neighbouring letters swapped (galsögon)
     - words under 5 letters are only fixed for å/ä/ö (rio, lima, sol, läs)
     - a slip that is as close to two words that mean different things is
       left alone

   The word lists are the one place to extend. Frame model names come from
   the store (layout/theme.liquid sets window.nvSearchModels), so new models
   need no change here. Longer phrases come first in WORDS, so
   "solglasögon" and "läsglasögon" are never read as "glasögon". */
(function () {
  'use strict';

  var WORDS = [
    // what it is for
    ['solglasögonen', 'sunglasses'], ['solglasögon', 'sunglasses'],
    ['läsglasögonen', 'reading glasses'], ['läsglasögon', 'reading glasses'],
    ['receptglasögonen', 'prescription glasses'], ['receptglasögon', 'prescription glasses'],
    ['synglasögonen', 'prescription glasses'], ['synglasögon', 'prescription glasses'],
    ['glasögonbågarna', 'frames'], ['glasögonbågar', 'frames'], ['glasögonbåge', 'frames'],
    ['glasögonen', 'glasses'], ['glasögon', 'glasses'],
    ['med styrka', 'prescription'], ['receptbelagda', 'prescription'], ['receptbelagt', 'prescription'],
    ['receptbelagd', 'prescription'], ['recept', 'prescription'],
    ['progressivglas', 'progressive'], ['progressiva', 'progressive'], ['progressiv', 'progressive'],
    ['varifokala', 'varifocal'], ['multifokala', 'multifocal'],
    ['enkelslipade', 'single vision'], ['enkelslip', 'single vision'],
    ['blåljusfilter', 'blue light'], ['blåljus', 'blue light'],
    ['polariserade', 'polarised'], ['polariserad', 'polarised'],
    ['bågarna', 'frames'], ['bågar', 'frames'], ['båge', 'frames'],
    ['läs', 'reading'], ['sol', 'sun'],
    // colours and materials
    ['sköldpaddsmönstrade', 'tortoise'], ['sköldpaddsmönstrad', 'tortoise'], ['sköldpadda', 'tortoise'],
    ['genomskinliga', 'transparent'], ['genomskinlig', 'transparent'], ['transparenta', 'transparent'],
    ['kristallklara', 'crystal clear'], ['kristallklar', 'crystal clear'], ['kristall', 'crystal'],
    ['svarta', 'black'], ['svart', 'black'], ['bruna', 'brown'], ['brun', 'brown'],
    ['gröna', 'green'], ['grön', 'green'], ['gråa', 'grey'], ['grå', 'grey'],
    ['blåa', 'blue'], ['blå', 'blue'], ['röda', 'red'], ['röd', 'red'], ['rosa', 'pink'],
    ['vita', 'white'], ['vit', 'white'], ['gula', 'yellow'], ['gul', 'yellow'],
    ['guldiga', 'gold'], ['guld', 'gold'], ['silvriga', 'silver'],
    ['kamouflage', 'camo'], ['bärnsten', 'amber'], ['havanna', 'havana'],
    ['klara', 'clear'], ['klar', 'clear'],
    // shape, size, who
    ['runda', 'round'], ['rund', 'round'], ['fyrkantiga', 'square'], ['fyrkantig', 'square'],
    ['rektangulära', 'rectangle'], ['rektangulär', 'rectangle'], ['ovala', 'oval'],
    ['kattögon', 'cat eye'], ['kattöga', 'cat eye'],
    ['stora', 'large'], ['stor', 'large'], ['små', 'small'], ['liten', 'small'], ['mellan', 'medium'],
    ['herrar', 'men'], ['herr', 'men'], ['damer', 'women'], ['dam', 'women'], ['unisex', 'unisex']
  ];

  // English words customers type, every word in the product names and every
  // frame model (2026-10-21). Known words are never corrected; they are also
  // what typos are corrected towards. Add new colour words here when products
  // arrive. Models also come from the store, but Shopify only lists the
  // first 50 there, so keep model names here too.
  var ENGLISH = (
    'glasses eyeglasses eyeglass spectacles optical frames frame prescription sunglasses sunglass shades sun ' +
    'reading readers reader progressive varifocal multifocal bifocal single vision blue light polarised polarized ' +
    'tortoise transparent crystal clear black brown green grey gray blue red pink white yellow gold silver camo ' +
    'amber havana round square rectangle oval cat eye large small medium men man women woman unisex junior kids ' +
    'clip ons chain case lenses lens ' +
    'aires athens atlantic barcelona beige beijing biarritz bilbao buenos cartagena champagne classic cloudy ' +
    'dakar dallas dark desert dusty florence forest gothenburg hamburg hong houston janeiro kingston klaro kong ' +
    'kyoto lima lisbon london madrid manila marble marrakech meadow melbourne milano milky mirror nairobi naples ' +
    'nashville nassau new nuuk ocean oslo palermo paris peach porto purple rain rio sand sandy seattle sepia ' +
    'shiny singapore sky sparkle spirit split stockholm summer sydney toulouse turquoise valencia vancouver ' +
    'vienna york arctic miami munich palma'
  ).split(' ');

  // Ordinary words that look like typos of ours but are not: never touched
  var LEAVE = (
    'night sight right bright glass order price prices return returns shipping delivery contact help gift ' +
    'card cards child children boys girls size sizes wide narrow sport driving computer screen safety ' +
    'storlek frakt retur returer leverans presentkort barn pris priser rea kontakt hjälp beställning'
  ).split(' ');

  // Word families: a start that can only mean one word, plus up to 4 letters
  var FAMILIES = [
    ['receptglasogon', 'receptglasögon'], ['synglasogon', 'synglasögon'],
    ['solglasogon', 'solglasögon'], ['lasglasogon', 'läsglasögon'],
    ['receptbel', 'receptbelagda'], ['progressiv', 'progressiva'], ['polariser', 'polariserade'],
    ['skoldpadd', 'sköldpadda'], ['genomskinl', 'genomskinliga'], ['kristallkl', 'kristallklara'],
    ['rektangul', 'rektangulära'], ['fyrkant', 'fyrkantiga'], ['glasogon', 'glasögon']
  ];

  var L = 'a-zåäöéü';

  function fold(s) {
    return s.toLowerCase().replace(/[åä]/g, 'a').replace(/ö/g, 'o').replace(/é/g, 'e').replace(/ü/g, 'u');
  }

  // Swedish word → its English meaning, so two candidates that mean the same
  // thing are not treated as a clash
  var MEANING = {
    sunglass: 'sunglasses', eyeglass: 'eyeglasses', reader: 'readers', frame: 'frames', lens: 'lenses',
    polarized: 'polarised', gray: 'grey', woman: 'women', man: 'men'
  };
  WORDS.forEach(function (w) { w[0].split(' ').forEach(function (p) { MEANING[p] = w[1]; }); });

  var vocab = null, known = null, byFold = null;
  function build() {
    if (vocab) return;
    var words = {};
    WORDS.forEach(function (w) {
      w[0].split(' ').forEach(function (p) { words[p] = 1; });
      w[1].split(' ').forEach(function (p) { words[p] = 1; });
    });
    ENGLISH.forEach(function (p) { words[p] = 1; });
    (window.nvSearchModels || []).forEach(function (m) {
      String(m).toLowerCase().split(/[^a-zåäöé]+/).forEach(function (p) { if (p) words[p] = 1; });
    });
    known = {};
    LEAVE.forEach(function (p) { known[p] = 1; });
    byFold = {};
    vocab = [];
    Object.keys(words).forEach(function (p) {
      known[p] = 1;
      var f = fold(p);
      byFold[f] = byFold[f] && byFold[f] !== p ? '?' : p;
      vocab.push({ w: p, f: f });
    });
  }

  // Optimal string alignment distance: wrong, missing or extra letter, or two
  // neighbouring letters swapped, each counts as one slip
  function slips(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var d = [];
    for (var i = 0; i <= la; i++) { d[i] = [i]; }
    for (var j = 0; j <= lb; j++) { d[0][j] = j; }
    for (i = 1; i <= la; i++) {
      var rowMin = max + 1;
      for (j = 1; j <= lb; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
    }
    return d[la][lb];
  }

  function fixWord(t) {
    if (t.length < 2 || /[^a-zåäöéü]/.test(t) || known[t]) return t;
    var f = fold(t);
    // å/ä/ö left out
    if (byFold[f] && byFold[f] !== '?') return byFold[f];
    // word families
    for (var i = 0; i < FAMILIES.length; i++) {
      var pre = FAMILIES[i][0];
      if (f.indexOf(pre) === 0 && f.length - pre.length <= 4) return FAMILIES[i][1];
    }
    if (t.length < 5) return t;
    var max = f.length >= 9 ? 2 : 1;
    var best = max + 1, hits = [];
    vocab.forEach(function (v) {
      if (v.w.length < 5 || (max === 2 && v.w.length < 8)) return;
      var s = slips(f, v.f, Math.min(max, best));
      if (s < best) { best = s; hits = [v.w]; }
      else if (s === best && s <= max) hits.push(v.w);
    });
    if (best > max || !hits.length) return t;
    var meaning = MEANING[hits[0]] || hits[0];
    for (i = 1; i < hits.length; i++) {
      if ((MEANING[hits[i]] || hits[i]) !== meaning) return t;
    }
    // Same meaning: prefer the main form (sunglasses over sunglass)
    return hits.indexOf(meaning) !== -1 ? meaning : hits[0];
  }

  // The customer's words with typos fixed, still in their own language
  function correct(q) {
    build();
    return String(q || '').toLowerCase().replace(/\s+/g, ' ').trim()
      .split(' ').map(fixWord).join(' ');
  }

  // Whole words only (letters incl. å ä ö), case-insensitive.
  function translate(q) {
    var s = ' ' + String(q || '').toLowerCase().replace(/\s+/g, ' ').trim() + ' ';
    WORDS.forEach(function (w) {
      var re = new RegExp('(^|[^' + L + '])' + w[0].replace(/ /g, '\\s+') + '(?=[^' + L + ']|$)', 'g');
      s = s.replace(re, '$1' + w[1]);
    });
    return s.replace(/\s+/g, ' ').trim();
  }

  function norm(q) { return String(q || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  // A search that is nothing but a category goes to that collection
  var ONLY = [
    [/^(prescription glasses|prescription|glasses|eyeglasses|spectacles|optical|prescription frames|frames)$/, '/collections/prescription-glasses'],
    // Lens types are chosen on a prescription frame; no product is named after them
    [/^(progressive|varifocal|multifocal|bifocal|single vision)( glasses| lenses)?$/, '/collections/prescription-glasses'],
    [/^(prescription sunglasses|sunglasses prescription)$/, '/collections/prescription-sunglasses'],
    [/^(sunglasses|sun|shades)$/, '/collections/sunglasses'],
    [/^(reading glasses|reading|readers)$/, '/collections/readers'],
    [/^(blue light|blue light glasses)$/, '/collections/blue-light-glasses']
  ];
  function categoryUrl(t) {
    for (var i = 0; i < ONLY.length; i++) if (ONLY[i][0].test(t)) return ONLY[i][1];
    return '';
  }

  function hidden(form, name, value) {
    var el = form.querySelector('input[name="' + name + '"]');
    if (value == null) { if (el) el.parentNode.removeChild(el); return; }
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; form.appendChild(el); }
    el.value = value;
  }

  // Results page and the dropdown's "Show all results": correct and
  // translate on submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/search(\?|$)/.test(form.getAttribute('action') || form.action)) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    var typed = norm(input.value);
    var fixed = correct(typed);
    var t = translate(fixed);
    var go = categoryUrl(t);
    if (go) {
      e.preventDefault();
      e.stopImmediatePropagation();
      location.href = go;
      return;
    }
    input.value = t;
    // Tell the results page what was corrected, so it can say so
    hidden(form, 'nv_c', fixed !== typed ? fixed : null);
    hidden(form, 'nv_o', fixed !== typed ? typed : null);
  }, true);

  // Type-ahead: correct and translate the query, and ask for enough products
  // to group (theme.js asks for 3; grouping needs a few of each kind).
  var lastFix = null;
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (resource, init) {
      try {
        var url = typeof resource === 'string' ? resource : (resource && resource.url);
        if (url && url.indexOf('/search/suggest') !== -1 && url.indexOf('section_id=search-results') !== -1) {
          var u = new URL(url, location.origin);
          var q = u.searchParams.get('q');
          if (q) {
            var typed = norm(q), fixed = correct(typed);
            lastFix = fixed !== typed ? { typed: typed, fixed: fixed } : null;
            u.searchParams.set('q', translate(fixed));
          }
          u.searchParams.set('resources[limit]', '10');
          u.searchParams.set('resources[limit_scope]', 'each');
          var next = u.pathname + u.search;
          resource = typeof resource === 'string' ? next : new Request(next, resource);
        }
      } catch (err) {}
      return origFetch.call(this, resource, init);
    };
  }

  // "Showing results for …" (built from text, never from HTML)
  function note(fixed, typed, withLink) {
    var p = document.createElement('p');
    p.className = 'nv-search-corrected';
    p.appendChild(document.createTextNode('Showing results for '));
    var b = document.createElement('strong');
    b.textContent = fixed;
    p.appendChild(b);
    if (withLink) {
      var a = document.createElement('a');
      a.className = 'nv-search-corrected__link';
      a.href = '/search?q=' + encodeURIComponent(typed);
      a.textContent = 'Search for “' + typed + '” instead';
      p.appendChild(a);
    }
    return p;
  }

  // Dropdown: add the line above the results whenever they are redrawn
  function markDropdown(box) {
    var old = box.querySelector('.nv-search-corrected');
    var res = box.querySelector('.predictive-search-results');
    var input = box.closest('form') && box.closest('form').querySelector('input[name="q"]');
    var current = input ? norm(input.value) : '';
    var want = lastFix && res && lastFix.typed === current;
    if (old && (!want || old.getAttribute('data-for') !== lastFix.typed)) { old.parentNode.removeChild(old); old = null; }
    if (want && !old) {
      var p = note(lastFix.fixed, lastFix.typed, false);
      p.setAttribute('data-for', lastFix.typed);
      box.insertBefore(p, box.firstChild);
    }
  }

  function boot() {
    // Results page: say what was corrected, and show the customer's own
    // words in the box rather than the English the search ran on
    try {
      var params = new URLSearchParams(location.search);
      var c = params.get('nv_c'), o = params.get('nv_o');
      var root = document.querySelector('.search-content');
      if (c && o && root && /^\/search/.test(location.pathname)) {
        var box = root.querySelector('input[name="q"]');
        if (box) box.value = c;
        var anchor = root.querySelector('predictive-search');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note(c, o, true), anchor.nextSibling);
      }
    } catch (err) {}
    // Both search boxes (header and results page) have their own dropdown
    if (window.MutationObserver) {
      [].forEach.call(document.querySelectorAll('predictive-search .search__results'), function (box) {
        new MutationObserver(function () { markDropdown(box); }).observe(box, { childList: true });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.nvSearchTranslate = function (q) { return translate(correct(q)); };
  window.nvSearchCorrect = correct;
})();
